import { render } from "./WCItemGroupSelector.vue?vue&type=template&id=5e0ddf06"
import script from "./WCItemGroupSelector.vue?vue&type=script&lang=js"
export * from "./WCItemGroupSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__